var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:[
    ("color-" + _vm.tagColor),
    _vm.textCentered ? 'text-center' : '',
    _vm.tableRow ? 'table-row-tag' : '' ]},[_c('span',[_vm._v("\n    "+_vm._s(_vm._f("thousandsSeparated")(_vm.label))+"\n  ")]),_vm._v(" "),(_vm.isClosable)?_c('button',{staticClass:"ml-1",on:{"click":_vm.onClose}},[_c('fa',{attrs:{"icon":['axis', 'clear'],"size":'1x'}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }